<template>
  <div class="horizontal layout center center-justified fit">
    <Loading />
  </div>
</template>

<script>
import utils from '@/util'

// components
import Loading from '@/components/Loading'

// services
import cookie from '@/services/cookie'

import { PRESENTER_REGISTER } from '@/constant/gaCategories'

export default {
  components: {
    Loading,
  },
  mounted() {
    const {
      token,
      signup,
      admin,
      email,
      provider,
      isNew,
    } = this.$route.query

    if (!token) {
      this.$router.push('/pages/login')
      return
    }

    this.$store.dispatch('setCurrentUserAction', {})

    if (isNew) {
      cookie.setValue('aha-new-user', true)
    }
    const isGuest = cookie.getValue('aha-guest-user')
    if (isGuest) {
      cookie.deleteValue('aha-guest-user')
    }

    utils.setCookieToken(token)
    this.$http.headers.common.Authorization = `Bearer ${token}`

    if (signup == 1) {
      this.$store.state.isComeFromSignupPage = true
      this.$router.push({ name: 'Presentations' })
      return
    }

    if (admin) {
      this.$router.push({
        path: '/apps/presentations',
        query: { admin: true },
      })
      this.$store.state.isAdmin = true
      return
    }

    if (provider) {
      const url = `/apps/presentations/app-signup-sso-success/?email=${email}`
      utils.gaTrackPageView(url, 'Signup SSO Success')

      utils.gaTrackEvent(
        PRESENTER_REGISTER, 'Sign up',
        'SSO',
        null,
        {
          provider,
        },
      )
      utils.ga4Track('sign_up', {
        method: 'SSO',
      })
    }

    this.$router.push('/apps/presentations')
  },
}
</script>
